import {Container, Box, Typography, Divider} from '@mui/material';
import {useLocation, useNavigate} from 'react-router-dom';

import {
  containerStyles,
  backButtonStyles,
  verticalDividerStyles,
  iconContainerStyles,
  paymentSuccessTitleStyles,
  paymentSuccessSubtitleStyles,
  paymentSuccessSubtitle2Styles,
  paymentSuccessButtonRowStyles,
  paymentSuccessOuterBoxStyles,
  paymentSuccessBackButtonExtraStyles,
  errorMessageStyles,
} from './styles';
import {CheckCircleBrokenIcon} from '$assets/svgs';
import FrontdeskButton from '$components/FrontdeskButton';
import {ArrowBack} from '@mui/icons-material';
import {useQueryClient} from '@tanstack/react-query';
import {PAYMENT_SUCCESS_STRINGS} from './constant';
import {
  useGenerateReciept,
  useSendReceipt,
} from '../../Finance/InvoiceDetails/hooks';
import moment from '~/utils/date';
import FetchError from '~/components/FetchError';

export default function PaymentSuccess() {
  const location = useLocation();
  const paymentId = location.state.paymentId;
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const {generateReceipt, isReceiptGenerating, isError} = useGenerateReciept();
  const {sendReceipt, isSending} = useSendReceipt();

  if (!paymentId) {
    return <FetchError />;
  }

  const handleSendReceipt = async () => {
    try {
      await sendReceipt(Number(paymentId));
      queryClient.invalidateQueries({queryKey: ['payment-details']});
      navigate(-1);
    } catch (error) {
      console.error('Failed to send receipt:', error);
    }
  };

  const handleReceiptDownload = async () => {
    const receiptData = await generateReceipt({payment_id: Number(paymentId)});

    const blob = new Blob([receiptData], {type: 'application/pdf'});
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = `Receipt_${moment().format('DD_MMM_YYYY')}.pdf`;

    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <Container sx={containerStyles}>
      <Box sx={{width: '100%'}}>
        <Box>
          <Box
            component="button"
            onClick={handleBack}
            sx={[backButtonStyles, paymentSuccessBackButtonExtraStyles]}
          >
            <ArrowBack sx={{mr: 1}} />
            {PAYMENT_SUCCESS_STRINGS.back}
          </Box>
        </Box>
        <Divider sx={verticalDividerStyles} />
        <Box sx={paymentSuccessOuterBoxStyles}>
          <Box className="icon-container" sx={iconContainerStyles}>
            <CheckCircleBrokenIcon />
          </Box>
          <Typography variant="h5" sx={paymentSuccessTitleStyles}>
            {PAYMENT_SUCCESS_STRINGS.title}
          </Typography>
          <Typography sx={paymentSuccessSubtitleStyles}>
            {PAYMENT_SUCCESS_STRINGS.subtitleLine1}
          </Typography>
          <Typography sx={paymentSuccessSubtitle2Styles}>
            {PAYMENT_SUCCESS_STRINGS.subtitleLine2}
          </Typography>
          <Box sx={paymentSuccessButtonRowStyles}>
            <FrontdeskButton
              className="highlight-purple"
              title={PAYMENT_SUCCESS_STRINGS.downloadReceipt}
              variant="secondary"
              onClick={handleReceiptDownload}
              disabled={isReceiptGenerating}
              loading={isReceiptGenerating}
            />
            <FrontdeskButton
              title={PAYMENT_SUCCESS_STRINGS.continue}
              variant="primary"
              onClick={handleSendReceipt}
              disabled={isSending}
            />
          </Box>
          {isError && (
            <Box sx={errorMessageStyles}>
              Failed to generate receipt. Please try again.
            </Box>
          )}
        </Box>
        <Divider sx={verticalDividerStyles} />
      </Box>
    </Container>
  );
}
